import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "uic-badge",
    styleUrl: "badge.scss"
})
export class Badge {
    /**
     * The number or text that gets shown above an element, for example number of notifications for an app
     */
    @Prop() value: number | string;

    /**
     * The smallest possible value. If the value is smaller, the badge is hidden.
     */
    @Prop() minValue = 1;

    /**
     * The highest possible number. If the value is higher, this limit together with a '+' is shown.
     */
    @Prop() maxValue = 99;

    render() {
        const value = typeof this.value === "string" ? parseInt(this.value, 10) : this.value;
        return (
            value >= this.minValue && (
                <Host>
                    <div class='uic-badge__content'>{value > this.maxValue ? this.maxValue + "+" : this.value}</div>
                </Host>
            )
        );
    }
}
